import Block from '../block'

export default class Foldable extends Block {
	static title = 'foldable'

	constructor($el) {
		super($el)

		this.inner = this.$el.findElement('inner')
		this.toggleContainer = this.$el.findElement('toggle-container')
		this.toggle = this.$el.findElement('toggle')
		this.toggleIcon = this.$el.findElement('icon')

		this.toggleSibling = this.$el.siblings('.foldable-sa-toggle')

		if (this.inner.outerHeight() <= this.$el.height()) {
			this.toggleContainer.addClass('hidden')
			if (this.toggleSibling) {
				this.toggleSibling.addClass('hidden')
			}
		}

		$(document).on('foldable:hide', () => {
			this.setActive(false)
			if (
				this.inner.outerHeight() > this.$el.height() &&
				!this.inner.hasClass('hidden')
			) {
				this.toggleContainer.removeClass('hidden')

				if (this.toggleSibling) {
					this.toggleSibling.removeClass('hidden')
				}
			} else {
				this.toggleContainer.addClass('hidden')

				if (this.toggleSibling) {
					this.toggleSibling.addClass('hidden')
				}
			}
		})

		this.toggle.on('click', () => {
			if (this.inner.outerHeight() > this.$el.height()) {
				this.setActive(true)
			} else {
				this.setActive(false)
			}
		})

		if (this.toggleSibling) {
			this.toggleSibling.find('.foldable__toggle').on('click', () => {
				if (this.$el.hasModifier('active')) {
					this.setActive(false)
				} else {
					this.setActive(true)
				}
			})
		}
	}

	setActive(bool) {
		if (bool) {
			this.$el.addModifier('active')
			this.toggleIcon.addClass('foldable__icon--active')

			if (this.toggleSibling) {
				this.toggleSibling
					.find('.foldable__icon')
					.addClass('foldable__icon--active')
			}
		} else {
			this.$el.removeModifier('active')
			this.toggleIcon.removeClass('foldable__icon--active')

			if (this.toggleSibling) {
				this.toggleSibling
					.find('.foldable__icon')
					.removeClass('foldable__icon--active')
			}
		}
	}
}
